/**
 * Promo code feedback around cart-discount.js (vendor bundle, do not edit):
 * - drop empty submits (the Apply button is never disabled)
 * - announce "already applied" (the vendor returns silently for it)
 * - show a short green confirmation after a successful apply. The vendor fires
 *   discount:update then morphs the section, so the message is shown after the
 *   morph. Free-shipping codes never fire the event; the vendor only unhides
 *   its shipping ref, which we watch instead.
 */
(() => {
  const FORM_SELECTOR = '.cart-discount__form';
  const ERROR_ID = 'cart-discount-error';
  const SUCCESS_SELECTOR = '[data-discount-success]';
  const SHIPPING_REF_SELECTOR = '[ref="cartDiscountErrorShipping"]';
  const SUCCESS_VISIBLE_MS = 8000;
  const SHIPPING_WATCH_MS = 6000;

  let pendingCode = null;
  let hideTimer = null;
  let shippingObserver = null;

  const showSuccess = (variant) => {
    // Query after the morph so we get the freshly rendered element
    setTimeout(() => {
      for (const box of document.querySelectorAll(SUCCESS_SELECTOR)) {
        const text = box.querySelector('[data-discount-success-text]');
        if (text) text.textContent = text.dataset[variant === 'shipping' ? 'textShipping' : 'textDefault'] ?? '';
        box.classList.remove('hidden');
      }
      clearTimeout(hideTimer);
      hideTimer = setTimeout(hideSuccess, SUCCESS_VISIBLE_MS);
    }, 100);
  };

  const hideSuccess = () => {
    for (const box of document.querySelectorAll(SUCCESS_SELECTOR)) box.classList.add('hidden');
  };

  const watchShippingRef = (component) => {
    shippingObserver?.disconnect();
    const ref = component.querySelector(SHIPPING_REF_SELECTOR);
    if (!ref) return;
    shippingObserver = new MutationObserver(() => {
      if (ref.classList.contains('hidden')) return;
      shippingObserver.disconnect();
      pendingCode = null;
      const input = component.querySelector('input[name="discount"]');
      if (input instanceof HTMLInputElement) input.value = '';
      showSuccess('shipping');
    });
    shippingObserver.observe(ref, { attributes: true, attributeFilter: ['class'] });
    setTimeout(() => shippingObserver?.disconnect(), SHIPPING_WATCH_MS);
  };

  const normalize = (code) => code.trim().toUpperCase();

  const appliedCodes = (component) =>
    [...component.querySelectorAll('.cart-discount__pill[data-discount-code]')].map((pill) =>
      normalize(pill.dataset.discountCode ?? '')
    );

  const setMessage = (component, visible) => {
    const box = component.querySelector(`#${ERROR_ID}`);
    const ours = component.querySelector('[data-discount-error-already-applied]');
    const input = component.querySelector('input[name="discount"]');
    if (!box || !ours || !input) return;

    for (const other of box.querySelectorAll('.cart-discount__error-text')) {
      if (other !== ours) other.classList.add('hidden');
    }
    ours.classList.toggle('hidden', !visible);
    box.classList.toggle('hidden', !visible);

    if (visible) input.setAttribute('aria-describedby', ERROR_ID);
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target instanceof Element ? event.target.closest(FORM_SELECTOR) : null;
      const component = form?.closest('cart-discount-component');
      const input = form?.querySelector('input[name="discount"]');
      if (!form || !component || !(input instanceof HTMLInputElement)) return;

      const code = normalize(input.value);
      if (code && !appliedCodes(component).includes(code)) {
        pendingCode = code;
        hideSuccess();
        watchShippingRef(component);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      if (code) setMessage(component, true);
      input.focus();
    },
    { capture: true }
  );

  document.addEventListener('discount:update', (event) => {
    if (!pendingCode) return;
    const codes = event.detail?.resource?.discount_codes ?? [];
    const applied = codes.some((entry) => normalize(entry.code ?? '') === pendingCode && entry.applicable === true);
    pendingCode = null;
    shippingObserver?.disconnect();
    if (applied) showSuccess('default');
  });

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.name !== 'discount') return;
    const component = input.closest('cart-discount-component');
    if (component) setMessage(component, false);
  });
})();
